import { Injectable } from '@angular/core';
import { filterNilValue, ID, Order, QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { AccountIssuer, AccountIssuerStatus } from './account-issuer.model';
import { AccountIssuersStore, AccountIssuersState } from './account-issuers.store';
import {
    flattenNestedObject,
    QueryFilterNew
} from 'src/app/shared/state/query-filter.functions';
import { checkFilter } from 'src/app/shared/state/query-filter.functions';
import { get } from 'dot-prop';
import { AccountIssuersService } from './account-issuers.service';

@Injectable({ providedIn: 'root' })
export class AccountIssuersQuery extends QueryEntity<AccountIssuersState> {
    constructor(
        protected store: AccountIssuersStore,
        private accountIssuerService: AccountIssuersService
    ) {
        super(store);
        this.accountIssuerService.get().subscribe();
    }

    public all$ = this.selectAll();

    public allAsObject$ = this.selectAll({ asObject: true });

    isLoading$ = this.selectLoading();

    selectIssuerById$ = (id: ID) => this.selectEntity(id).pipe(filterNilValue());

    getIssuerById = (id: ID) => this.getEntity(id);

    selectIssuersByFilter$(
        filters?: QueryFilterNew<AccountIssuer>,
        sortBy: keyof AccountIssuer | any = 'accountIssuerId',
        sortByOrder: Order = Order.ASC
    ): Observable<AccountIssuer[]> {
        return this.selectAll({
            sortBy,
            sortByOrder,
            filterBy: (issuer) => {
                // ...flatten nested object and filter out null values
                const FILTERS = Object.entries<any>(flattenNestedObject(filters)).filter(
                    (filter) => filter[1] !== null
                );
                if (FILTERS.length > 0) {
                    return !FILTERS.find(([key, criteria]) => {
                        const value = get<string | number>(issuer, key);
                        return !checkFilter(value, criteria);
                    });
                } else {
                    return true;
                }
            }
        });
    }

    /** @deprecated - This function should not be used */
    public filterBy(
        filters?: QueryFilterNew<AccountIssuer>
    ): Observable<Array<AccountIssuer>> {
        return this.selectAll({
            filterBy: (issuer) => {
                // ...flatten nested object and filter out null values
                const FILTERS = Object.entries<any>(flattenNestedObject(filters)).filter(
                    (filter) => filter[1] !== null
                );
                return !FILTERS.find(([key, criteria]) => {
                    const value = get<string | number>(issuer, key);
                    return !checkFilter(value, criteria);
                });
            }
        });
    }

    isLoading(request: string): Observable<boolean> {
        return this.select('ui').pipe(pluck(request), pluck('isLoading'));
    }
}
